import React from 'react';
import { Typography } from 'antd';
import Configuration from 'src/containers/Configuration';
import { createUseStyles } from 'react-jss';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../hooks/store';

const { Title } = Typography;

const useStyles = createUseStyles({
  configurationLayout: {
    textAlign: 'center',
  },
});

/**
 * The 'Config' component is used to display your group tabs
 * user configuration options.  Here you will allow the user to
 * make their choices and once they are done you will need to validate
 * their choices and communicate that to Teams to enable the save button.
 */
const TabConfig: React.VFC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { user } = useAppSelector(({ auth }) => auth);

  return (
    <div className={classes.configurationLayout}>
      <Title level={4}>{t('tabConfiguration.title')}</Title>

      {user?.role === 'admin' ? (
        <Configuration />
      ) : (
        <Title level={5} type="danger">
          Vous devez être administrateur de l'équipe pour pouvoir afficher la
          fenêtre de configuration
        </Title>
      )}
    </div>
  );
};

export default TabConfig;
